import React, { Component } from "react";
import { Col } from "react-bootstrap";
import { Api } from "../utils/api";
import { UserCard } from "./components/user_card.component";
import { UserRequestStats } from "./components/user_request_stats.component";
import { EstablishmentRequestListCard } from "./components/establishment_request_list_card.component";
import { EstablishmentFilterCard } from "./components/establishment_filter_card.component";
import { RequestDetailsCard } from "./components/request_details_card.component";
import { NewRequestCard } from "./components/new_request_card.component";
import { withRouter } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@material-ui/core/Button";
import { NotificationManager } from "react-notifications";
import ToolsButton from "../components/tools_button.component";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import ConfirmDialog from "../components/confirm.component";
import AlertDialog from "../components/alert.component";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";

class UserRequestView extends Component {
  state = {
    userRequest: null,
    establishmentRequests: [],
    establishmentRequestsMaxRound: null,
    showConfirm: false,
    showAlert: false,
    showLoading: false,
    showError: false,
    showPleaseFillInputs: false,
    search_county: null,
    search_parish: null,
    dateFromLastBookcall: null,
    userRequestStats: null,
  };

  constructor() {
    super();
    this.api = new Api();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.send = this.send.bind(this);
    this.getEstablishmentRequests = this.getEstablishmentRequests.bind(this);
    this.sendEstablishmentRequests = this.sendEstablishmentRequests.bind(this);
    this.showConfirm = this.showConfirm.bind(this);
    this.closeConfirm = this.closeConfirm.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.showLoading = this.showLoading.bind(this);
    this.hideLoading = this.hideLoading.bind(this);
    this.showError = this.showError.bind(this);
    this.closeError = this.closeError.bind(this);
    this.showPleaseFillInputs = this.showPleaseFillInputs.bind(this);
    this.closePleaseFillInputs = this.closePleaseFillInputs.bind(this);
    this.getDateFromLastBookcall = this.getDateFromLastBookcall.bind(this);
    this.getUserRequestInfo = this.getUserRequestInfo.bind(this);
    this.getStatsData = this.getStatsData.bind(this);
    this.updateStatsInfo = this.updateStatsInfo.bind(this);
    this.messageTextFromStats = this.messageTextFromStats.bind(this);
  }

  getEstablishmentRequests() {
    const { id } = this.props.match.params;
    return this.api
      .get(`user_requests/${id}/establishment_requests`)
      .then(({ data = null }) => {
        this.setState({ establishmentRequests: data.establishment_requests });
        this.setState({
          establishmentRequestsMaxRound: data.max_round_nr[0].max_round_nr,
        });
      });
  }

  getUserRequestInfo = async () => {
    const { id } = this.props.match.params;
    if (id === "new") {
      this.setState({ userRequest: {} });
      return;
    }

    await this.api
      .get(`/user_requests/${id}`)
      .then(({ data = null }) => this.setState({ userRequest: data }))
      .then(this.getEstablishmentRequests)
      .then(this.getDateFromLastBookcall);
  };

  goTo(location) {
    this.props.history.replace(location);
  }

  componentDidMount = async () => {
    await this.getUserRequestInfo();
    this.getStatsData();
  };

  componentDidUpdate(prevProps) {
    const { id } = this.props.match.params;

    if (prevProps.match.params.id === id) {
      return;
    }

    if (id === "new") {
      this.setState({ userRequest: {} });
      return;
    }

    this.api
      .get(`/user_requests/${id}`)
      .then(({ data = null }) => this.setState({ userRequest: data }));
    this.getEstablishmentRequests();
  }

  handleSubmit(values, action = "update") {
    const { id } = this.props.match.params;
    if (id === "new") {
      return this.api
        .post(`user_requests/`, {
          ...values,
          search_closest_counties: values.closest_county,
          search_closest_parishes: values.closest_parish,
        })
        .then(({ data: userRequest }) => {
          this.goTo(`/user_requests/${userRequest.id}`);
          this.setState({ userRequest });
          NotificationManager.success("Pedido criado com sucesso", "Pedidos");
        })
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          NotificationManager.error(
            "Houve um erro a completar o seu pedido",
            "Pedidos"
          );
        });
    } else {
      return this.api
        .patch(`user_requests/${id}`, {
          ...values,
          message_from_stats: this.messageTextFromStats(),
        })
        .then(({ data: userRequest }) => {
          this.setState({ userRequest });
          if (action === "update") {
            NotificationManager.success(
              "Pedido actualizado com sucesso",
              "Pedidos"
            );
            setTimeout(() => {
              window.location.reload();
            }, 500); //refresh page after 500ms
          }
          if (action === "cancel") {
            NotificationManager.success(
              "Pedido cancelado com sucesso",
              "Pedidos"
            );
          }
        })
        .catch(() => {
          NotificationManager.error(
            "Houve um erro a completar o seu pedido",
            "Pedidos"
          );
        });
    }
  }

  send() {
    const { id } = this.props.match.params;
    if (!id) return;
    this.api
      .post(`/user_requests/${id}/send_request_emails`)
      .then(({ data: userRequest }) => {
        this.setState({ userRequest });
        NotificationManager.success("Emails enviados com sucesso", "Pedidos");
      })
      .catch(() => {
        this.setState({ message: "Error Handling Email Request" });
        NotificationManager.error(
          "Houve um erro ao enviar os emails",
          "Pedidos"
        );
      });
  }

  sendOfferEmail = (event) => {
    const { userRequest } = this.state;
    event.target.style.color = "gray";
    this.api
      .post("/internal_families_emails", {
        type: "OFFER",
        user_request_id: userRequest.id,
      })
      .then(() => {
        NotificationManager.success(
          "Email para a família enviado com sucesso.",
          "Pedidos"
        );
      })
      .catch((err) => {
        console.log(err);
        NotificationManager.error(
          "Houve um erro ao enviar o email para a família.",
          "Pedidos"
        );
      });
  };

  sendEstablishmentRequests() {
    const establishmentsToSent = this.state.establishmentRequests.filter(
      (e) => !e.sent_at
    );
    let max_round =
      this.state.establishmentRequestsMaxRound !== null
        ? this.state.establishmentRequestsMaxRound
        : 0;

    this.closeConfirm();
    this.showLoading();

    establishmentsToSent.map((e) => {
      this.api
        .patch(`/establishment_requests/${e.id}/`, {
          round_nr: max_round + 1,
          round_county: this.state.userRequest.closest_county,
          round_parish: this.state.userRequest.closest_parish,
        })
        .then(() =>
          this.api.post(`/establishment_requests/${e.id}/send_request_emails`)
        )
        .then(async () => {
          await this.getEstablishmentRequests();
          this.showAlert();
        })
        .catch(() => {
          this.setState({ message: "Error Handling Email Request" });
          this.showError();
        });
    });
  }

  showConfirm() {
    this.setState({ showConfirm: true });
  }

  closeConfirm() {
    this.setState({ showConfirm: false });
  }

  showAlert() {
    this.setState({ showAlert: true });
  }

  closeAlert() {
    this.refreshPage();
  }

  showLoading() {
    this.setState({ showLoading: true });
  }

  hideLoading() {
    this.setState({ showLoading: false });
  }

  showError() {
    this.setState({ showError: true });
  }

  closeError() {
    this.setState({ showError: false });
  }

  showPleaseFillInputs() {
    this.setState({ showPleaseFillInputs: true });
  }

  closePleaseFillInputs() {
    this.setState({ showPleaseFillInputs: false });
  }

  refreshPage() {
    window.location.reload(false);
  }

  //método que chama a data do ultimo agendamento registado
  getDateFromLastBookcall = () => {
    const { id } = this.props.match.params;
    return this.api
      .get(`bookcalls`, { user_request_id: id })
      .then(({ data = null }) => {
        this.setState({ dateFromLastBookcall: data });
      });
  };

  //get informations from on hi_user_requests_info
  getStatsData = () => {
    return this.api
      .get(`/user_request_infos/${this.state.userRequest.user_request_info_id}`)
      .then((data) => {
        this.setState({ userRequestStats: data.data });
      });
  };

  //update statistics on hi_user_requests_info
  updateStatsInfo = async (values) => {
    const { id } = this.props.match.params;
    await this.api
      .patch(`/user_request_infos/${this.state.userRequestStats.id}`, values)
      .then(async () => {
        await this.getStatsData();
        this.api.patch(`user_requests/${id}`, {
          message_from_stats: this.messageTextFromStats(),
        });
      })
      .then(async () => {
        await NotificationManager.success(
          "Guardado com sucesso",
          "Estatisticas"
        );
        window.location.reload();
      })
      .catch(() => {
        NotificationManager.error("Erro ao gravar", "Estatisticas");
      });
  };

  // create message with inputs from statistics
  messageTextFromStats = () => {
    let userRequestStats = this.state.userRequestStats;
    if (userRequestStats) {
      let message = "";
      message =
        (userRequestStats.age ? userRequestStats.age + " anos; " : "") +
        (userRequestStats.gender ? userRequestStats.gender_label + "; " : "") +
        (userRequestStats.motive && userRequestStats.motive !== 22
          ? userRequestStats.motive_label + "; "
          : "") +
        (userRequestStats.mobility
          ? userRequestStats.mobility_label + "; "
          : "") +
        (userRequestStats.room_type
          ? userRequestStats.room_type_label + "; "
          : "") +
        (userRequestStats.autonomy_level
          ? userRequestStats.autonomy_label
          : "") +
        (userRequestStats.health_problem &&
        userRequestStats.health_problem !== 14
          ? "; " + userRequestStats.health_problem_label
          : "") +
        (userRequestStats.pension_aids && userRequestStats.pension_aids !== 7
          ? "; " + userRequestStats.pension_aids_label + ". "
          : ".");
      return message;
    }
  };

  render() {
    const { userRequest, establishmentRequestsMaxRound } = this.state;
    const { id } = this.props.match.params;
    const establishmentsToSent =
      this.state.establishmentRequests.filter((e) => !e.sent_at).length > 0;
    const groupedEstablishmentRequests = [];

    //ultima ronda na base de dados - caso n exista, devolve 0
    let max_round =
      establishmentRequestsMaxRound !== null
        ? establishmentRequestsMaxRound
        : 0;

    const orderedRequests = this.state.establishmentRequests.sort((r0, r1) => {
      if (r0.round_nr === r1.round_nr) return 0;
      return r0.round_nr < r1.round_nr ? 1 : -1;
    });
    var g = { date: null, requests: [] },
      current_round = null;

    orderedRequests.forEach((r, idx) => {
      //first item
      if (!current_round) {
        current_round = r.round_nr;
        g.date = moment(r.sent_at)
          .locale("pt-PT")
          .format("DD-MM-YYYY HH:mm:ss");
        g.title =
          (r.sent_at && r.origin_search === "map") ||
          (r.sent_at && r.origin_search === "name")
            ? `Ronda ${current_round} - Pesquisa por ${
                r.origin_search === "name" ? "Nome" : "Mapa"
              }`
            : r.sent_at && r.round_county !== null && r.monthly_payment !== null
            ? `Ronda ${current_round} - ${r.round_county_name} - ${r.round_parish_name} - ${r.monthly_payment} euros`
            : r.sent_at && r.round_county !== null && r.monthly_payment === null
            ? `Ronda ${current_round} - ${r.round_county_name} - ${r.round_parish_name} - Formulário de Equipamento`
            : r.sent_at && r.round_county === null
            ? `Ronda ${current_round}`
            : "";
      }
      //next items (same round)
      if (current_round === r.round_nr) g.requests.push(r);
      //next items (other rounds)
      else {
        groupedEstablishmentRequests.push(g);
        current_round = r.round_nr;
        g = {
          date: moment(r.sent_at).locale("pt-PT").format("DD-MM-YYYY HH:mm:ss"),
          title:
            (r.sent_at && r.origin_search === "map") ||
            (r.sent_at && r.origin_search === "name")
              ? `Ronda ${current_round} - Pesquisa por ${
                  r.origin_search === "name" ? "Nome" : "Mapa"
                }`
              : r.round_nr &&
                r.round_county !== null &&
                r.monthly_payment !== null
              ? `Ronda ${r.round_nr} - ${r.round_county_name} - ${r.round_parish_name} - ${r.monthly_payment} euros`
              : r.sent_at &&
                r.round_county !== null &&
                r.monthly_payment === null
              ? `Ronda ${current_round} - ${r.round_county_name} - ${r.round_parish_name} - Formulário de Equipamento`
              : r.round_nr && r.round_county === null
              ? `Ronda ${r.round_nr}`
              : "",
          requests: [r],
        };
      }
      if (idx === this.state.establishmentRequests.length - 1)
        groupedEstablishmentRequests.push(g);
    });

    return (
      <>
        {userRequest && (
          <Col>
            <ToolsButton
              getDateFromLastBookcall={this.getDateFromLastBookcall}
              context_type="UserRequest"
              context_id={id}
            />

            {userRequest.id && (
              <>
                <UserCard user={userRequest} handleSubmit={this.handleSubmit} />
                <UserRequestStats
                  updateStatsInfo={this.updateStatsInfo}
                  userRequestStats={this.state.userRequestStats}
                  //handleSubmitMessage={this.handleSubmit}
                />

                <RequestDetailsCard
                  userRequestStats={this.state.userRequestStats}
                  getUserRequestInfo={this.getUserRequestInfo}
                  request={userRequest}
                  dateFromLastBookcall={this.state.dateFromLastBookcall}
                  handleSubmit={this.handleSubmit}
                />
                <br></br>

                <EstablishmentFilterCard
                  request={userRequest}
                  messageTextFromStats={this.messageTextFromStats}
                  handleSubmit={this.handleSubmit}
                  refreshEstablishments={this.getEstablishmentRequests}
                  establishmentRequests={this.state.establishmentRequests}
                />

                {userRequest.request_type === "Disperso" &&
                  userRequest.is_canceled === false && (
                    <Button
                      variant="contained"
                      color="secondary"
                      size="medium"
                      className="hand-button"
                      onClick={this.send}
                    >
                      <FontAwesomeIcon icon="mail-bulk" />
                      <span className="disperse-mail">Dispersar</span>
                    </Button>
                  )}

                <EstablishmentRequestListCard
                  key={userRequest.id}
                  userRequest={userRequest}
                  isCanceled={userRequest.is_canceled}
                  disperseRequest={userRequest.request_type === "Disperso"}
                  establishmentRequests={this.state.establishmentRequests}
                  groupedEstablishmentRequests={groupedEstablishmentRequests}
                  onRemove={this.getEstablishmentRequests}
                  maxRound={max_round}
                />

                {this.state.userRequestStats && (
                  <Grid
                    container
                    justify="center"
                    alignItems="center"
                    className="send-mail"
                  >
                    <Tooltip title={"Encaminhar para todos os equipamentos"}>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={
                          this.state.userRequestStats.gender !== null &&
                          this.state.userRequest.closest_county !== null &&
                          this.state.userRequest.closest_parish !== null &&
                          this.state.userRequest.name !== ""
                            ? this.showConfirm
                            : this.showPleaseFillInputs
                        }
                        disabled={!establishmentsToSent}
                      >
                        {/*<FontAwesomeIcon icon="envelope"/>*/}
                        <span className="mail-padding">Encaminhar</span>
                      </Button>
                    </Tooltip>
                  </Grid>
                )}
              </>
            )}
            {!userRequest.id && (
              <NewRequestCard
                userRequestStats={this.state.userRequestStats}
                request={userRequest}
                handleSubmit={this.handleSubmit}
              />
            )}
          </Col>
        )}
        <ConfirmDialog
          open={this.state.showConfirm}
          title={"Atenção"}
          message={
            "Proceder com o encaminhamento para todos os equipamentos listados?\nConfirma que já enviou todos os SMS?"
          }
          handleOk={this.sendEstablishmentRequests}
          handleCancel={this.closeConfirm}
        ></ConfirmDialog>
        <AlertDialog
          open={this.state.showAlert}
          title={"Sucesso"}
          message={"Encaminhamentos realizados!"}
          handleClose={this.closeAlert}
        ></AlertDialog>
        <AlertDialog
          open={this.state.showError}
          title={"Erro"}
          message={"Ocorreu um erro a realizar os encaminhamentos!"}
          handleClose={this.closeError}
        ></AlertDialog>
        <AlertDialog
          open={this.state.showPleaseFillInputs}
          title={"Atenção"}
          message={
            "Para encaminhar, preencha por favor os dados do pedido, do utilizador e a análise da situação."
          }
          handleClose={this.closePleaseFillInputs}
        ></AlertDialog>
        <div
          hidden={!this.state.showLoading}
          className="credit-notes-loading-div"
        >
          <CircularProgress color="primary" />
        </div>
      </>
    );
  }
}

export default withRouter(UserRequestView);
